import { pageUrl } from "../../utils/hosts";

export const API_URL = pageUrl(process.env.REACT_APP_API_URL);

export const DWA_API_URL = pageUrl(process.env.REACT_APP_DWA_URL);
export const DWA_WS_URL = pageUrl(process.env.REACT_APP_WS_URL);

export const PELIAS_API_URL = pageUrl(process.env.REACT_APP_PELIAS_API_URL);

export const MAPBOX_URL = process.env.REACT_APP_MAPBOX_URL;
export const MAPBOX_URL_DARK = process.env.REACT_APP_MAPBOX_DARK_URL;
export const MANUAL_GET_PROJECT = process.env.REACT_APP_MANUAL_GET_PROJECT;
export const LANDING_URL = pageUrl(process.env.REACT_APP_LANDING_URL);
export const STRIPE_SECRET_KEY = process.env.REACT_APP_STRIPE_SECRET_KEY;
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const WS_API_URL = pageUrl(process.env.REACT_APP_WS_API_URL);

// Define paths to use it when showing backdrop, and to ignore them when rendering project by route
export const paths = [
  "projects",
  "vehicles",
  "drivers",
  "tags",
  "notifications",
  "apps",
  "route-setup",
  "account",
  "developers",
  "billing",
  "payment"
];

export const rightDrawerWidth = 280;
export const maxNoteLength = 2500;

export const defaultCapacity = 101994;
export const defaultWeight = 101994;
export const defaultVolume = 101994;

export const currencies = {
  GBP: { symbol: "£", string: "GBP" },
  EUR: { symbol: "€", string: "EUR" },
  USD: { symbol: "$", string: "USD" }
};

export const routeColors = [
  "#cc3d3e",
  "#3d67cc",
  "#91cc3d",
  "#cc3dbb",
  "#3dccb3",
  "#cc893d",
  "#5f3dcc",
  "#44cc3d",
  "#cc3d6d",
  "#3d97cc",
  "#ad3dcc",
  "#3dcc83",
  "#cc593d",
  "#3d4acc",
  "#73cc3d",
  "#cc3d9d",
  "#3dc7cc",
  "#7d3dcc",
  "#3dcc53",
  "#cc3d50",
  "#3d79cc",
  "#a3cc3d",
  "#ca3dcc",
  "#3dcca1",
  "#cc773d",
  "#4d3dcc",
  "#56cc3d",
  "#cc3d7f"
];

export const headerRow = [
  "type",
  "name",
  "street",
  "city",
  "postal_code",
  "country_code",
  "lat",
  "long",
  "duration",
  "from",
  "to",
  "email",
  "phone",
  "priority",
  "pod_signature",
  "pod_age",
  "pod_photo",
  "delivery_note",
  "vehicle_tags",
  "driver_tags",
  "unit_count",
  "unit_weight",
  "unit_volume",
  "unit_id",
  "unit_note",
  "tracking_id"
];

export const APP_STOPS_HEADER_ROW = [
  "status",
  "due_date",
  "project_number",
  "type",
  "recipient_name",
  "street",
  "city",
  "postal_code",
  "country",
  "lat",
  "lng",
  "duration",
  "earliest_time",
  "latest_time",
  "email",
  "phone",
  "priority",
  "signature",
  "age",
  "photo",
  "delivery_note",
  "unit_count",
  "unit_weight",
  "unit_volume",
  "tracking_id"
];

// Map constants
export const CLUSTERING_MAX_ZOOM = 13;

export const TILES_URLS = {
  STADIAMAPS:
    "https://tiles.stadiamaps.com/tiles/outdoors/{z}/{x}/{y}{r}.png?api_key=3d08e19b-0914-45a8-ad27-8b89a6433709",
  STADIAMAPS_DARK:
    "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png?api_key=3d08e19b-0914-45a8-ad27-8b89a6433709",
  STADIA:
    "https://tiles.stadiamaps.com/tiles/outdoors/{z}/{x}/{y}{r}.png?api_key=3d08e19b-0914-45a8-ad27-8b89a6433709",
  STADIA_DARK:
    "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png?api_key=3d08e19b-0914-45a8-ad27-8b89a6433709",
  OPENSTREETMAP: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  MAPTILER:
    "https://api.maptiler.com/maps/streets/{z}/{x}/{y}.png?key=LsWRkadKQ8Rs5XbzeBlL"
};

export const MAP_USE_RASTER = true;

export const MAP_RASTER_URLS = {
  STADIA:
    "https://tiles.stadiamaps.com/tiles/outdoors/{z}/{x}/{y}{r}.png?api_key=3d08e19b-0914-45a8-ad27-8b89a6433709",
  STADIA_DARK:
    "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png?api_key=3d08e19b-0914-45a8-ad27-8b89a6433709"
};

export const MAP_VECTOR_URLS = {
  STADIA:
    "https://tiles.stadiamaps.com/styles/outdoors.json?api_key=3d08e19b-0914-45a8-ad27-8b89a6433709",
  STADIA_DARK:
    "https://tiles.stadiamaps.com/styles/alidade_smooth_dark.json?api_key=3d08e19b-0914-45a8-ad27-8b89a6433709"
};

// Notification template tags
export const COMMON_TAGS = {
  recipient_name: "{{recipient_name}}",
  project_date: "{{project_date}}"
};

export const DELIVERED_TAGS = {
  completion_time: "{{completion_time}}"
};

export const NOT_DELIVERED_TAGS = {
  time_window: "{{time_window}}",
  ETA: "{{ETA}}"
};

export const SMS_TAGS = {
  tracking_link: "{{tracking_link}}"
};

export const EMAIL_TAGS = {
  tracking_link: "[link text](#tracking_link)",
  tracking_button: "[button text](#tracking_button)",
  custom_link: "[custom link text](https://customlink.com/)"
};

// Notification template action texts
export const ACTION_TEXTS = {
  project_publish:
    "Once you publish a project, all the recipients within that project will receive a notification through the selected channel.",
  route_start: `Once your driver clicks on "Start route", all the recipients within that route will receive a notification through the selected channel.`,
  stop_delivered:
    "Once a stop has been delivered, the recipient will receive a notification through the selected channel.",
  stop_skipped:
    "Once a stop has been skipped, the recipient will receive a notification through the selected channel."
};

export const TEMPLATE_TYPES = {
  actions: {
    project_publish: "Project is published",
    route_start: "Driver starts a route",
    stop_delivered: "Stop delivered",
    stop_skipped: "Stop skipped"
  },
  templates: {
    sms: "SMS",
    email: "Email"
  }
};

export const TAB_IDS = {
  UPCOMING: "UPCOMING",
  ACTIVE: "ACTIVE",
  PAST: "PAST"
};

export const COMPANY_TYPE_PREDEFINED_VALUES = [
  "Courier / Post",
  "Retail / eCommerc",
  "Meal Delivery",
  "Medical / Pharmacy",
  "Flower / Gifts",
  "Laundry / Drycleaning",
  "Rental",
  "Service"
];
